/**
 * A bolha OTIMISTA do turno — a frase que o consultor acabou de mandar e que
 * `apiChatModoAgente.js::aceitarRun` grava ANTES do `POST /runs` (é o que dá
 * resposta instantânea ao Enter).
 *
 * Quando o aceite é RECUSADO, essa bolha vira mentira: a mensagem está no
 * thread como se tivesse sido enviada, e não foi. Dois chamadores precisam
 * recolhê-la, e é por isso que a regra mora aqui em vez de duplicada nos dois:
 *
 * - a degradação para o Modo Chat, que vai reenviar o MESMO texto por outra
 *   porta (sem recolher, o consultor veria a própria frase duas vezes);
 * - o 409 "conversa ocupada", em que o turno simplesmente não aconteceu — e a
 *   resposta que vier será da pergunta ANTERIOR, com a nova pendurada acima
 *   dela como se tivesse sido respondida.
 *
 * ★ A régua é deliberadamente ESTREITA: só a ÚLTIMA mensagem, só se for do
 * usuário, só se ainda não tiver `id` do servidor e só se o conteúdo for o
 * texto que acabamos de tentar despachar. Qualquer coisa fora disso não é a
 * bolha deste turno e fica onde está — perder mensagem de conversa é pior que
 * mostrar uma repetida.
 *
 * @param {Array} mensagens A lista do store (`<ns>/messages`).
 * @param {string} texto O texto que o aceite tentou despachar.
 * @returns {Array|null} A lista sem a bolha, ou `null` quando ela não é desta
 *   tentativa (aí o chamador não mexe em nada).
 */
export function semBolhaOtimista(mensagens, texto) {
  const lista = mensagens || []
  const ultima = lista[lista.length - 1]
  const ehDesteTurno =
    ultima && !ultima.id && ultima.role === 'user' && ultima.content === texto
  return ehDesteTurno ? lista.slice(0, -1) : null
}
